export default function NotFound() {

    return ( 
        <div>
        </div>
    )
}